import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Alert from "react-bootstrap/Alert";
import {
  fetchDiscardedTransactionData,
  restoreTransactionRecord,
} from "../services/errorMessageQueue-service";
import { discardQueueHeadCells } from "../util/headcells-util";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import { getAllFacilities } from "../services/sendingFacilities-service";
import { fetchErrorCodes } from "../services/error-codes-service";
import { urlWithFilterParams, validateAndSanitizeUrl } from "../util/common";
import { FixedSizeList } from "react-window";
import { fetchConditions } from "../services/conditions-service";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const DiscardQueue = () => {
  const location = useLocation();
  const [showRestoreWarningModal, setShowRestoreWarningModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [discardTransactionData, setDiscardTransactionData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(location?.state?.pageNo ? location?.state?.pageNo : 0 );
  const [isFetchError, setIsFetchError] = useState(false);
  const [isRestored, setIsRestored] = useState(false);
  const [isError, setIsError] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [filter, setFilter] = useState(
    location?.state?.filter ? location?.state?.filter : {msh12Not:["eicr"]}
  );
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [facilityData, setFacilityData] = useState([]);
  const [errorCodes, setErrorCodes] = useState([]);
  const [checkedValues, setCheckedValues] = useState(location?.state?.filter?.sendingFacilityName ? location?.state?.filter?.sendingFacilityName :[]);
  const [checkedErrorTypeValues, setCheckedErrorTypeValues] = useState(location?.state?.filter?.errorCode ? location?.state?.filter?.errorCode :[]);
  const [conditionCheckedValues, setConditionCheckedValues] = useState(
    location?.state?.filter?.condition ? location?.state?.filter?.condition : []
  );
  const [conditions, setConditions] = useState([]);
  const handleRestoreWarningModalClose = () =>
    setShowRestoreWarningModal(false);

  const handleFilterModalClose = () => setShowFilterModal(false);

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const getFacilities = async () => {
    let response = await getAllFacilities();
    if (response.ok) {
      let data = await response.json();
      setFacilityData(data);
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const getErrorCodes = async () => {
    let response = await fetchErrorCodes();
    if (response.ok) {
      let data = await response.json();
      setErrorCodes(data);
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const handleResetFilter = () => {
    setFilter({msh12Not:["eicr"]});
    setCheckedValues([]);
    setCheckedErrorTypeValues([]);
    setConditionCheckedValues([]);
  };

  const handleShowFilter = () => {
    setIsError(false);
    setIsRestored(false);
    getFacilities();
    getErrorCodes();
    setShowFilterModal(true);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getDiscardedTransactionData(filter);
    handleFilterModalClose();
  };

  const handleSendingFacilityCheckboxChange = (event) => {
    let copyCheckedValues = [...checkedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setCheckedValues(copyCheckedValues);
    setFilterField("sendingFacilityName", copyCheckedValues);
  };

    const handleCheckboxChange = (
    newValue,
    conditionCheckedValues,
    setConditionCheckedValues,
    filter
  ) => {
    let copyCheckedValues = [...conditionCheckedValues];

    if (copyCheckedValues.includes(newValue)) {
      copyCheckedValues = copyCheckedValues.filter((item) => item !== newValue);
    } else {
      copyCheckedValues = [...copyCheckedValues, newValue];
    }
    setConditionCheckedValues(copyCheckedValues);
    setFilterField(filter, copyCheckedValues);
  };

  const handleErrorTypeCheckboxChange = (event) => {
    let copyCheckedValues = [...checkedErrorTypeValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setCheckedErrorTypeValues(copyCheckedValues);
    setFilterField("errorCode", copyCheckedValues);
  };

  const getDiscardedTransactionData = useCallback(
    async (filter) => {
      let response = await fetchDiscardedTransactionData(
        pageNo,
        recordsPerPage,
        urlWithFilterParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          const genericList = data?.genericList.map((item) => ({
            ...item, 
            clia:  item?.sendingFacility?.clia,
            transactionErrors: item?.transactionError?.slice(0, 3)?.map(item => `${item?.errorRef?.errorDisplayName} (${item?.errorCode})`).join('\n')
         }));
         const data2={...data, genericList : genericList}
          setIsFetchError(false);
          setIsError(false);
          setDiscardTransactionData(data2);
        } else {
          setIsFetchError(true);
          setIsError(true);
        }
      } else {
        let error = await response.json();
        if (error.description === "No Discarded Transaction record found!") {
          setIsFetchError(false);
          setIsError(false);
          setDiscardTransactionData({
            genericList: [],
            totalPages: 0,
            totalRecords: 0,
          });
        } else {
          setIsFetchError(true);
          setIsError(true);
          setAlertMessage(error?.description);
        }
      }
    },
    [pageNo, recordsPerPage]
  );

    const getConditions = async () => {
    let response = await fetchConditions();
    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        setConditions(data);
      } else {
        // setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      // setAlertMessage(error?.description);
    }
  };

  useEffect(() => {
    getDiscardedTransactionData(filter);
    getConditions();
  }, [pageNo, recordsPerPage, getDiscardedTransactionData]);

  useEffect(() => {
    if (isRestored) {
      getDiscardedTransactionData(filter);
    }
  }, [isRestored, getDiscardedTransactionData]);

  useEffect(() => {
    if (pageNo >= discardTransactionData?.totalPages) {
      discardTransactionData?.totalPages !== 0 &&
        setPageNo(discardTransactionData?.totalPages - 1);
    }
  }, [discardTransactionData]);

  const handleRestore = () => {
    setShowRestoreWarningModal(true);
    setIsRestored(false);
    setIsError(false);
  };

  const restoreTransaction = async () => {
    let response = await restoreTransactionRecord(selectedRow.transactionId);
    if (response !== ERROR_MSG) {
      setIsRestored(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRestoreWarningModalClose();
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleRestore}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Restore
        </Button>
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isRestored) {
      return "Successfully restored error message";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (filter?.startDate || filter?.endDate) {
      active.push("0");
    }
    if (checkedValues.length > 0) {
      active.push("1");
    }
    if (checkedErrorTypeValues.length > 0) {
      active.push("2");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Discard Queue</Row>
            <Row className="tableSubtitle generalFont">
              You have{" "}
              {discardTransactionData?.totalRecords > 0
                ? discardTransactionData.totalRecords
                : 0}{" "}
              Error Messages Awaiting action
            </Row>
          </Col>
        </Row>
        {(isRestored || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsRestored(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={discardQueueHeadCells}
          rows={discardTransactionData?.genericList}
          pages={discardTransactionData?.totalPages}
          buttonsLayout={buttonsLayout}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isDiscardQueueTable={true}
          filter={filter}
          pageNo={pageNo}
        />
      </Container>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label fullWidth sx={{ m: 1 }}>
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Identifier"
                value={filter.id ? filter.id : ""}
                onChange={(e) =>
                  setFilterField(
                    "id",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br></br>
            <br></br>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Message Control ID"
                value={filter.messageControlId ? filter.messageControlId : ""}
                onChange={(e) =>
                  setFilterField(
                    "messageControlId",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Specimen ID"
                value={filter.specimenId ? filter.specimenId : ""}
                onChange={(e) =>
                  setFilterField(
                    "specimenId",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="CLIA"
                value={filter.clia ? filter.clia : ""}
                onChange={(e) =>
                  setFilterField(
                    "clia",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
               <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Conditions</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        conditions.sort((a, b) =>
                          a.conditionName.localeCompare(b.conditionName)
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={conditionCheckedValues.includes(
                                  conditions[index].conditionName
                                )}
                                onChange={() =>
                                  handleCheckboxChange(
                                    conditions[index].conditionName,
                                    conditionCheckedValues,
                                    setConditionCheckedValues,
                                    "conditions"
                                  )
                                }
                                name={conditions[index].conditionName}
                              />
                            }
                            label={conditions[index].conditionName}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Time Transaction Received</div>
                </Accordion.Header>
                <Accordion.Body>
                  <Form.Group className="mb-3" controlId="form.startDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        Start Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.startDate ? filter.startDate : ""}
                      onChange={(e) =>
                        setFilterField("startDate", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="form.endDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        End Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.endDate ? filter.endDate : ""}
                      onChange={(e) =>
                        setFilterField("endDate", e.target.value)
                      }
                    />
                  </Form.Group>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Sending Facility</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        facilityData.sort((a, b) =>
                          a.sendingFacilityName.localeCompare(
                            b.sendingFacilityName
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedValues.includes(
                                  facilityData[index].sendingFacilityName
                                )}
                                onChange={handleSendingFacilityCheckboxChange}
                                name={facilityData[index].sendingFacilityName}
                              />
                            }
                            label={facilityData[index].sendingFacilityName}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>{" "}
              <br />
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div className="bold">Error Type</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "scroll",
                    overflowX: "hidden",
                  }}
                >
                  <FormGroup>
                    {errorCodes
                      .sort((a, b) => (a.errorCode > b.errorCode ? 1 : -1))
                      .map((item) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedErrorTypeValues.includes(
                                  item?.errorCode
                                )}
                                onChange={handleErrorTypeCheckboxChange}
                                name={item?.errorCode}
                              />
                            }
                            label={
                              item?.errorDisplayName + "-" + item?.errorCode
                            }
                          />
                        );
                      })}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRestoreWarningModal}
        onHide={handleRestoreWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Restore Error Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to restore this error message back to error
              queue?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRestoreWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={restoreTransaction}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Restore
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DiscardQueue;
